import { useMemo } from 'react';
import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';

interface OffersEntry {
  id: string, 
  business_id: string, 
  created_at: string, 
  expires_at: string, 
  target_payback_period_days: number | string, 
  maximum_amount: number, 
  originated_amount: number, 
  available_amount: number, 
  currency: string, 
  status: string, 
  boosted: boolean | string 
}

interface OffersTableProps {
  offersData: { data: OffersEntry[] }; // Ensure this matches the type you're passing
}



const OffersTable: React.FC<OffersTableProps> = ({ offersData }) => {
  // Memoized columns to prevent re-creation on re-renders
  const columns = useMemo<MRT_ColumnDef<OffersEntry>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'ID',
        size: 100,
      },
    {
        accessorKey: 'business_id',
        header: 'Business ID',
        size: 100,
    },
    {
        accessorKey: 'created_at',
        header: 'Created At',
        size: 100,
    },
    {
        accessorKey: 'expires_at',
        header: 'Expires At',
        size: 100,
    },
    {
        accessorKey: 'target_payback_period_days',
        header: 'Target Payback Period Days',
        size: 100,
    },
    {
        accessorKey: 'maximum_amount',
        header: 'Maximum',
        size: 100,
        Cell: ({ row }) => `${row.original.currency.toUpperCase()} ${(row.original.maximum_amount/ 100).toFixed(2)}`,

    },
    {
        accessorKey: 'originated_amount',
        header: 'Originated',
        size: 100,
        Cell: ({ row }) => `${row.original.currency.toUpperCase()} ${(row.original.originated_amount/ 100).toFixed(2)}`,

    },
    {
        accessorKey: 'available_amount',
        header: 'Available',
        size: 100,
        Cell: ({ row }) => `${row.original.currency.toUpperCase()} ${(row.original.available_amount / 100).toFixed(2)}`,

    },
    {
        accessorKey: 'status',
        header: 'Status',
        size: 100,
    },
    {
        accessorKey: 'boosted',
        header: 'Boosted',
        size: 100,
    }
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: offersData.data, // Matches the shape of your updated webhookData
    initialState: { columnVisibility: { boosted:false, business_id:false} }, 
  });

  return <MaterialReactTable table={table} />;
};

export default OffersTable;
